import React, { PureComponent } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import axios from "axios";
import CollapseItem from "./CollapseItem";
import { CLOUDINARY_THUMB } from "../../helpers/cloudinaryConstants";

export default class BusinessAdminsModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      users: {
        owners: [],
        managers: []
      }
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.fetchAdmins();
    }
  }

  fetchAdmins() {
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    axios
      .get(`/api/proxy/v2/businesses/${this.props.business.id}/admins`, {
        headers
      })
      .then(({ data }) => {
        this.setState({ users: data });
      })
      .catch(err => {
        console.log(err);
      });
  }

  renderOwners() {
    return this.state.users.owners.map(owner => (
      <a
        href={`${APP_BASE_URL}/users/${owner.username}`}
        target="__blank"
        rel="noopener noreferrer"
      >
        <li style={{ display: "flex", alignItems: "center", padding: 10 }}>
          <div className="avatar">
            <img
              src={`${CLOUDINARY_THUMB}/${owner.avatar.image.cloudinaryId}`}
              className="img-avatar"
              alt={owner.username}
            />
          </div>
          <div style={{ marginLeft: 10 }}>{owner.username}</div>
        </li>
      </a>
    ));
  }

  renderManagers() {
    return this.state.users.managers.map(manager => (
      <a
        href={`${APP_BASE_URL}/users/${manager.username}`}
        target="__blank"
        rel="noopener noreferrer"
      >
        <li style={{ display: "flex", alignItems: "center", padding: 10 }}>
          <div className="avatar">
            <img
              src={`${CLOUDINARY_THUMB}/${manager.avatar.image.cloudinaryId}`}
              className="img-avatar"
              alt={manager.username}
            />
          </div>
          <div>{manager.username}</div>
        </li>
      </a>
    ));
  }

  render() {
    const { business } = this.props;
    const { users } = this.state;
    return business ? (
      <Modal
        isOpen={this.props.isOpen}
        className={this.props.className}
        toggle={this.toggle}
      >
        <ModalHeader toggle={this.props.close}>{business.name}</ModalHeader>
        <ModalBody>
          <CollapseItem buttonText={`View Owners (${users.owners.length}) `}>
            <ul>{this.renderOwners()}</ul>
          </CollapseItem>
          <CollapseItem
            buttonText={`View Managers (${users.managers.length})
            }`}
          >
            <ul>{this.renderManagers()}</ul>
          </CollapseItem>
        </ModalBody>
      </Modal>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/views/Components/BusinessAdminsModal.js